import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import PlayIcon from '../assets/play-icon.svg?react';

const Button = styled.button`
    position: absolute;
    outline: none;
    background-color: var(--blue400);
    border-radius: 4px;
    height: 48px;
    width: 48px;
    border: none;
    cursor: pointer;
    transition: background-color 0.5s ease;

    & > img {
        width: 24px;
        height: 24px;
        border-radius: 11px;
        box-shadow: var(--shadow-4);
        outline: none;
        vertical-align: middle;
    }

    &:disabled {
        background-color: var(--gray200);
        box-shadow: none;
        cursor: initial;
    }

    &:focus {
        box-shadow: var(--outline);
    }

    &:active {
        box-shadow: none;
    }

    &:hover:not(:disabled) {
        background-color: var(--blue700);
    }

    &::-moz-focus-inner {
        border: 0;
    }
`;

const PlayButton = ({ onClick, disabled }) => {
    return (
        <Button onClick={onClick} onMouseUp={(event) => event.target.blur()} aria-label="Play button" disabled={disabled}>
            <img tabIndex="-1" src={PlayIcon} alt="Play icon" />
        </Button>
    );
};

PlayButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

export default PlayButton;
